import Icon, { IconProps } from './Icon';
import ThumbsUpIcon from '../../../assets/icons/thumbs-up.svg?react';

const ThumbsDown: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props} rotate={180}>
            <ThumbsUpIcon />
        </Icon>
    );
};

export default ThumbsDown;
